import { useEffect, useState } from "react";

export const useCheckFormErrors = (errors) => {
    const [anyErrors, setAnyErrors] = useState(false);

    useEffect(() => {
        const keys = Object.keys(errors);

        setAnyErrors(keys.some((key) => errors[key]));
    }, [errors]);

    return anyErrors;
}